/**
 * ATTENTION! This file is auto-generated for the 'comments' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import type { CommentRepository } from '../server/repositories/CommentRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type CommentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<CommentRepository>;
export function useCommentRepository(): CommentRepositoryClient { return makeRepositoryProxy<CommentRepositoryClient>('comments::CommentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useCommentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const commentRepository = useCommentRepository();
